import { DecodableAgent } from "decodable-agent";

import { createContext, useContext } from "react";
import config from "../config";

export const AgentContext = createContext<DecodableAgent | null>(null);

export function AgentProvider({ children }) {
  const isLocal =
    window.location.origin.includes("localhost") ||
    !config.DATADOG_CLIENT_TOKEN;

  const ctx = isLocal
    ? DecodableAgent.withLocalProvider()
    : DecodableAgent.withDataDogProvider({
        credentials: {
          clientToken: config.DATADOG_CLIENT_TOKEN,
        },
        service: "web-app",
        version: config.GIT_SHA,
        env: config.DECODABLE_ENV,
      });
  return <AgentContext.Provider value={ctx}>{children}</AgentContext.Provider>;
}

export function useAgent() {
  const agent = useContext(AgentContext);

  if (!agent) {
    throw new Error(
      "useAgent may only be used in the context of a AgentProvider"
    );
  }

  return agent;
}
